import * as React from "react";

function SvgBBiconsWarningNotice(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <g data-name="Obecn\xE9 ikony">
        <circle cx={100} cy={100} r={99} />
        <path
          d="M92.55 106.71l-2.17-32.46q-.61-9.5-.61-13.63 0-5.62 2.94-8.77a10.16 10.16 0 017.77-3.15q5.82 0 7.79 4t2 11.62a87.55 87.55 0 01-.47 9.08l-2.91 33.42a26.19 26.19 0 01-2 9.14 5.31 5.31 0 01-5.15 3.19 5.13 5.13 0 01-5.08-3.08 30.54 30.54 0 01-2.11-9.36zm7.52 44.59a10.69 10.69 0 01-7.22-2.67 9.38 9.38 0 01-3.08-7.49A10.06 10.06 0 0199.93 131a10 10 0 017.29 3 9.62 9.62 0 013 7.15 9.42 9.42 0 01-3 7.45 10.34 10.34 0 01-7.15 2.7z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default SvgBBiconsWarningNotice;
